import type { SuppressionItem } from '../../cataloglifecycle/framework';
import { cn } from '../../lib/cn';
import { Button } from '../ui/Button';

type Props = { items?: SuppressionItem[] };

function severityColor(severity: SuppressionItem['severity']) {
  switch (severity) {
    case 'high': return 'border-error-200 bg-error-50 dark:border-error-900 dark:bg-error-950/30';
    case 'medium': return 'border-warning-200 bg-warning-50 dark:border-warning-900 dark:bg-warning-950/30';
    default: return 'border-slate-200 dark:border-slate-700';
  }
}

export function SuppressionCenterPanel({ items = [] }: Props) {
  return (
    <div className="space-y-3">
      {items.map((item) => (
        <div key={item.asin} className={cn('rounded-lg border p-3', severityColor(item.severity))}>
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="text-sm font-medium">{item.title}</p>
              <p className="font-mono text-xs text-slate-500">{item.asin}</p>
            </div>
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium capitalize',
              item.severity === 'high' ? 'bg-error-100 text-error-700' : 'bg-warning-100 text-warning-700',
            )}>
              {item.severity}
            </span>
          </div>
          <p className="mt-2 text-xs text-error-600 dark:text-error-400">{item.reason}</p>
          <p className="mt-1 text-xs text-slate-600 dark:text-slate-400">Fix: {item.fix}</p>
          <Button variant="secondary" size="sm" className="mt-2">Republish</Button>
        </div>
      ))}
    </div>
  );
}
